import React from 'react';
import { Search, SlidersHorizontal } from 'lucide-react';
import { useContestFilters } from '../../../stores/contestFilters';

export const ContestFilters = () => {
  const { search, status, sortBy, setSearch, setStatus, setSortBy } = useContestFilters();

  return (
    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Recherche */}
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="block w-full pl-10 pr-3 py-2.5 bg-white/5 border border-white/10 text-white rounded-xl placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500/50 focus:border-transparent"
            placeholder="Rechercher un concours..."
          />
        </div>

        {/* Statut */}
        <div className="relative">
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="block w-full pl-3 pr-10 py-2.5 bg-white/5 border border-white/10 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-yellow-500/50 focus:border-transparent appearance-none"
          >
            <option value="" className="bg-gray-900">Tous les statuts</option>
            <option value="draft" className="bg-gray-900">À venir</option>
            <option value="active" className="bg-gray-900">Actif</option>
            <option value="ended" className="bg-gray-900">Terminé</option>
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <SlidersHorizontal className="h-5 w-5 text-gray-400" />
          </div>
        </div>

        {/* Tri */}
        <div className="relative">
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="block w-full pl-3 pr-10 py-2.5 bg-white/5 border border-white/10 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-yellow-500/50 focus:border-transparent appearance-none"
          >
            <option value="" className="bg-gray-900">Trier par</option>
            <option value="name" className="bg-gray-900">Nom</option>
            <option value="start_date" className="bg-gray-900">Date de début</option>
            <option value="contestants" className="bg-gray-900">Participants</option>
            <option value="votes" className="bg-gray-900">Votes</option>
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <SlidersHorizontal className="h-5 w-5 text-gray-400" />
          </div>
        </div>
      </div>
    </div>
  );
};
